import * as Sentry from '@sentry/react';
import { createBrowserRouter, Navigate } from 'react-router-dom';
import { AuthLayout } from '@/app/layouts/auth-layout';
import { MainLayout } from '@/app/layouts/main-layout';
import { CMORecordsStepPage } from '@/app/pages/cmo-records/[step]';
import { DatabasePage } from '@/app/pages/database';
import { ErrorPage } from '@/app/pages/error';
import { NotFoundPage } from '@/app/pages/not-found';
import { RecordsPage } from '@/app/pages/records';
import { RecordDetailPage } from '@/app/pages/records/[record-id]';
import { SettingsPage } from '@/app/pages/settings';
// 페이지 - Lazy loading
import { SignInPage } from '@/app/pages/signin';
import { SignUpPage } from '@/app/pages/signup';
import CMORecordsLayout from '@/features/cmo-records/ui/layout';
import { ProtectedRoute } from '@/widgets/auth/protected-route';

// Sentry가 라우터 네비게이션을 추적하도록 설정 (React Router v7용)
const sentryCreateBrowserRouter = Sentry.wrapCreateBrowserRouterV7(createBrowserRouter);

export const router = sentryCreateBrowserRouter([
  // 루트 리다이렉트
  {
    path: '/',
    element: (
      <Navigate
        replace
        to="/cmo-records/1"
      />
    ),
  },
  // 인증 라우트 (비로그인)
  {
    element: <AuthLayout />,
    errorElement: <ErrorPage />,
    children: [
      { path: '/signin', element: <SignInPage /> },
      { path: '/signup', element: <SignUpPage /> },
    ],
  },
  // 보호된 라우트 (로그인 필요)
  {
    element: (
      <ProtectedRoute>
        <MainLayout />
      </ProtectedRoute>
    ),
    errorElement: <ErrorPage />,
    children: [
      { path: '/records', element: <RecordsPage /> },
      { path: '/records/:recordId', element: <RecordDetailPage /> },
      { path: '/database', element: <DatabasePage /> },
      { path: '/database/:masterId', element: <DatabasePage /> },
      {
        path: '/cmo-records',
        element: <CMORecordsLayout />,
        children: [
          {
            index: true,
            element: (
              <Navigate
                replace
                to="/cmo-records/1"
              />
            ),
          },
          { path: ':step', element: <CMORecordsStepPage /> },
        ],
      },
      { path: '/settings', element: <SettingsPage /> },
    ],
  },
  // 404
  {
    path: '*',
    element: <NotFoundPage />,
  },
]);
